import { render } from "./ListEvalPatient.vue?vue&type=template&id=087a6550&scoped=true&ts=true"
import script from "./ListEvalPatient.vue?vue&type=script&lang=ts"
export * from "./ListEvalPatient.vue?vue&type=script&lang=ts"

import "./ListEvalPatient.vue?vue&type=style&index=0&id=087a6550&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DanhGia_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087a6550"]])

export default __exports__